import { render, staticRenderFns } from "./AS_PmSurya.vue?vue&type=template&id=81df18b6&scoped=true&"
import script from "./AS_PmSurya.vue?vue&type=script&lang=js&"
export * from "./AS_PmSurya.vue?vue&type=script&lang=js&"
import style0 from "./AS_PmSurya.vue?vue&type=style&index=0&id=81df18b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df18b6",
  null
  
)

export default component.exports